import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VerificationMarketerRoutingModule } from './verification-marketer-routing.module';
import { SharedModule } from '@shared/shared.module';
import { MatCoreModule } from '@shared/material/mat-core.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    VerificationMarketerRoutingModule,
    SharedModule,
    MatCoreModule,
  ]
})
export class VerificationMarketerModule { }
